import { render, staticRenderFns } from "./registrar.vue?vue&type=template&id=255b9970&scoped=true&"
import script from "./registrar.vue?vue&type=script&lang=js&"
export * from "./registrar.vue?vue&type=script&lang=js&"
import style0 from "./registrar.vue?vue&type=style&index=0&id=255b9970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b9970",
  null
  
)

export default component.exports